var prevScrollPos = window.pageYOffset || document.documentElement.scrollTop;
$(window).scroll(function () {
  var sticky = $('.header'),
    scroll = $(window).scrollTop();
  if (scroll >= 50) {
    sticky.addClass('header-fixed');
    sticky.addClass('header-fixed-active');
    sticky.removeClass('header-fixed-os');
  } else {
    sticky.removeClass('header-fixed');
    sticky.removeClass('header-fixed-active');
    sticky.addClass('header-fixed-os');
  }
  var currentScrollPos = window.pageYOffset || document.documentElement.scrollTop;
  if (prevScrollPos > currentScrollPos || currentScrollPos === 0) {
    $('.header').removeClass('header-hidden');
  } else {
    $('.header').addClass('header-hidden');
  }

  prevScrollPos = currentScrollPos;
});

// // --- Smooth transition for header-top and header-main ---
// (function ($) {
//   let isHidden = false;

//   $(window).on('scroll', function () {
//     const header = $('.header');

//     if (header.hasClass('header-fixed-active')) {
//       if (!isHidden) {
//         isHidden = true;
//         $('.header-top, .header-main')
//           .stop(true, true)
//           .css({ opacity: 1, display: 'block' })
//           .animate({ opacity: 0, marginTop: '-10px' }, 300, function () {
//             $(this).css({ display: 'none', marginTop: '0' });
//           });
//       }
//     } else {
//       if (isHidden) {
//         isHidden = false;
//         $('.header-top, .header-main')
//           .stop(true, true)
//           .css({ display: 'block', opacity: 0, marginTop: '-10px' })
//           .animate({ opacity: 1, marginTop: '0' }, 300);
//       }
//     }
//   });
// })(jQuery);

// --- Smooth transition for header-top and header-main (desktop only ≥ 992px) ---
(function ($) {
  let isHidden = false;

  $(window).on('scroll', function () {
    // ✅ Only apply on desktop screens
    if ($(window).width() < 992) return;

    const header = $('.header');

    if (header.hasClass('header-fixed-active')) {
      if (!isHidden) {
        isHidden = true;
        $('.header-top, .header-main')
          .stop(true, true)
          .css({ opacity: 1, visibility: 'visible', maxHeight: '100px' })
          .animate({ opacity: 0, marginTop: '-10px', maxHeight: '0' }, 300, function () {
            $(this).css({ visibility: 'hidden', marginTop: '0' });
          });
      }
    } else {
      if (isHidden) {
        isHidden = false;
        $('.header-top, .header-main')
          .stop(true, true)
          .css({ visibility: 'visible', opacity: 0, marginTop: '-10px', maxHeight: '0' })
          .animate({ opacity: 1, marginTop: '0', maxHeight: '100px' }, 300, function () {
            $(this).css({ maxHeight: 'none' });
          });
      }
    }
  });

  // ✅ Reset visibility instantly when resizing below 992px
  $(window).on('resize', function () {
    if ($(window).width() < 992) {
      $('.header-top, .header-main').stop(true, true).css({
        visibility: 'visible',
        opacity: 1,
        marginTop: '0',
        maxHeight: 'none',
      });
      isHidden = false;
    }
  });
})(jQuery);

$(document).ready(function () {
  $('.menu-nav-items li')
    .has('.mega-menu-nav')
    .hover(
      function () {
        $('.header').addClass('header-bg');
        $('body').addClass('header-body-bg');
        $('body').addClass('overflow-hidden');
      },
      function () {
        $('.header').removeClass('header-bg');
        $('body').removeClass('header-body-bg');
        $('body').removeClass('overflow-hidden');
      }
    );
  $('.menu-nav-link').on('click', function () {
    e.preventDefault();
  });
});

$(document).ready(function () {
  $('.hamburger').on('click', function () {
    $(this).addClass('d-none');
    $('.res-header-menus').addClass('res-header-active');
    $('.header').addClass('res-menu-active');
    $('.hamburger-close').removeClass('d-none');
    $('.res-header-menus').removeClass('d-none');
    $('html').addClass('overflow-hidden');
    $('body').addClass('overflow-hidden');
  });

  $('.hamburger-close').on('click', function () {
    $(this).addClass('d-none');
    $('.hamburger').removeClass('d-none');
    $('.res-header-menus').addClass('d-none').removeClass('d-flex');
    $('html').removeClass('overflow-hidden');
    $('body').removeClass('overflow-hidden');
    $('.header').removeClass('res-menu-active');
  });

  $('.res-card').on('click', function (e) {
    // e.preventDefault();
    $('.res-card').hide();
    $('.mega-menu-nav').hide();
    $(this).siblings('.mega-menu-nav').show();
    $('.res-menu-items').hide();
  });
  $('.back-btn').on('click', function (e) {
    // e.preventDefault();
    $('.res-card').show();
    $('.mega-menu-nav').show();
    $('.mega-menu-nav').hide();
    $('.res-menu-items').show();
  });

  $(document).ready(function () {
    $('.header-search-btn').on('click', function () {
      $(this).addClass('active');
      $('.header-btn').addClass('hide');
      $('.search-input').addClass('active');
      $('.header').addClass('header-search-active');
      $('.input-close').removeClass('d-none');
      $('.header').removeClass('res-menu-active');
    });

    $(document).ready(function () {
      $('.header-input').on('input', function () {
        if ($(this).val().trim() !== '') {
          $(this).addClass('active').removeClass('hide');
          $('.search-suggestion-content').addClass('active');
          $('body').addClass('header-body-bg');
          $('body').addClass('overflow-hidden');
        } else {
          $(this).removeClass('active').addClass('hide');
          $('.search-suggestion-content').removeClass('active');
          $('body').removeClass('header-body-bg');
          $('body').removeClass('overflow-hidden');
        }
      });
    });

    $('.input-close').on('click', function () {
      $('.search-input').removeClass('active');
      $('.header-input').val('');
      $('.header').removeClass('header-search-active');
      $('.input-close').removeClass('d-none');
      $('.header-btn').removeClass('hide');
      $('.header-search-btn').removeClass('active');
      $('.search-suggestion-content').removeClass('active');
      $(this).addClass('d-none');
      $('body').removeClass('header-body-bg');
      $('body').removeClass('overflow-hidden');
      $('.res-header-menus').addClass('d-none');
      $('.hamburger').removeClass('d-none');
      $('.hamburger-close').addClass('d-none');
      $('html').removeClass('overflow-hidden');
    });
  });
});
